module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "OT"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("Contents")])]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _c('p', {
    staticClass: "TocSb1",
    attrs: {
      "id": "for"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/foreword#for"
    }
  }, [_vm._v("Foreword")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1a",
    attrs: {
      "id": "int"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction#int"
    }
  }, [_vm._v("INTRODUCTION: PARENTING FOR A BETTER WORLD")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "s001"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction#s001"
    }
  }, [_vm._v("The Long Game")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "s002"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction#s002"
    }
  }, [_vm._v("Raising Children with Justice for Justice")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "s003"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction#s003"
    }
  }, [_vm._v("Raising Ourselves")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "s004"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction#s004"
    }
  }, [_vm._v("Partnering with Children in Doing Justice")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-001"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("A WHOLE GOSPEL FOR A WHOLE CHILD")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch1s1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#s001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Evolution of Parenting")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch1s2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#s002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Good News for the Children")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch1s3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#s003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dismantling Our Blind Spots")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-002"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#ch002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("GOOD NEWS FOR THE BODY")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch2s1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#s001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("When Touch Honors Consent")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch2s2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#s002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Agency in Clothing and Food")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch2s3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#s003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sexual Agency")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-003"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#ch003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("PARENTING FOR IMAGINATION")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch3s1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#s001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Creative Agents")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch3s2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#s002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Keeping the Magic")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-004"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004#ch004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("HEALTHY SPIRITUALITY")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch4s1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004#s001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Parenting with a Shifting Faith")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch4s2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004#s002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Belonging over Conversion")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch4s3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004#s003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tools of Investigation")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch4s4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004#s004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Freedom of Exploration")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch4s5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004#s005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Crucible of Love")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-005"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter005#ch005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("PARENTING FOR RACIAL JUSTICE")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch5s1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter005#s001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Are Children Racists?")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch5s2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter005#s002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Note to Parents of White Children")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch5s3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter005#s003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Let’s Talk about Race")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-006"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter006#ch006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("PARENTING FOR GENDER EQUALITY")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch6s1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter006#s001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("We Should All Be Feminists")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch6s2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter006#s002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("For Our Boys")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch6s3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter006#s003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Girls and Anger")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch6s4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter006#s004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Disobedience")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch6s5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter006#s005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Embodied Life")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-007"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter007#ch007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("PARENTING FOR ECONOMIC AND ENVIRONMENTAL JUSTICE")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch7s1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter007#s001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Brief History of Consumerism and Children")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch7s2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter007#s002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("You’re Grounded!")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch7s3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter007#s003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Out to the Wild")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch7s4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter007#s004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Tree of Sustainable Life")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch7s5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter007#s005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ethical Consumption")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch7s6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter007#s006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Family Table")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-008"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter008#ch008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("PARENTING FOR INCLUSION")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch8s1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter008#s001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Church’s Complicity in Homophobia")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch8s2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter008#s002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gender and Sexuality 101")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch8s3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter008#s003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Uniquely You")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch8s4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter008#s004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Activism")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch8s5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter008#s005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Faithfulness")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-009"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter009#ch009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("CHILDREN AS RADICAL HOPE")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch9s1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter009#s001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Changing Us")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch9s2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter009#s002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Changing the World")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "note"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#note",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2176abdc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 63
// module chunks = 0